import React from "react";
import "./Delivery_options.css";

function Delivery_options({ imgSrc, headingText, describe }) {
  return (
    <>
      <section className="Delivery_options">
        <div className="main_img_holder">
          <div className="img_holder">
            <img
              src={process.env.PUBLIC_URL + imgSrc}
              className="Delivery_img"
              alt="Delivery_img"
            />
          </div>
        </div>
        <div className="Delivery_heading_holder">
          <h5>{headingText}</h5>
          <p>{describe}</p>
        </div>
      </section>
    </>
  );
}

export default Delivery_options;
